import React from "react";
import { useDispatchWrapper } from "../../../../../../hooks";
import { IUploadPdfDocumentProcess } from "../../../../../../redux/aiReconciliation/aiReconciliation.types";
import { ERROR_MESSAGES } from "../../../../../../constants/enums";
import { api } from "../../../../../../api/api";
import { showMessage } from "../../../../../../redux/messages/messagesActions";
import {
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { CheckCircleOutlined, ErrorOutline } from "@mui/icons-material";

export interface IInsuranceReportsMVRTracker {
  processCode: string | null;
  path: string | null;
  customer_policy_id: number;
  onRetry: (proccessCode: string) => void;
}

export const InsuranceReportsMVRTracker: React.FC<
  IInsuranceReportsMVRTracker
> = (props) => {
  const { processCode, path, customer_policy_id, onRetry } = props;

  const dispatch = useDispatchWrapper();
  const [state, setState] = React.useState<IUploadPdfDocumentProcess | null>(
    null
  );
  const [error, setError] = React.useState<string | null>(null);

  const fetchData = async (proccessCode: string, interval?: any) => {
    try {
      const res = await api.get(
        `/general/get-process?process_records_code=${proccessCode}&pageNo=1&itemPerPage=1`
      );
      const resData: IUploadPdfDocumentProcess[] = res.data.data;
      if (resData.length > 0) {
        const data = resData[0];
        if (data.status === "COMPLETED") {
          setState(data);

          clearInterval(interval);
        } 
        else if (data.status === "FAILED") {
          setState(data);
          clearInterval(interval);
          setError(ERROR_MESSAGES.SERVER_ERROR);
        }
      }
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  const handleRetry = async () => {
    try {
        setState(null);
      const res = await api.post(`/general/extract-mvr-abstracts-with-gen-ai`, {
        url: path,
        customer_policy_id: customer_policy_id,
      });
      const process_records_code = res.data.data["process_records_code"];
      onRetry(process_records_code || null)
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  React.useEffect(() => {
    let interval: any;
    if (processCode) {
      interval = setInterval(() => {
        fetchData(processCode, interval);
      }, 10000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [processCode]);

  const renderData = () => {
    if (!state || state.status === "IN_PROGRESS") {
      return (
        <>
          {/* <Breadcrumb
                    title="Extract Products"
                    items={BCrumb}
                /> */}
          <Stack spacing={1} direction={"row"} alignItems={"center"}>
            <CircularProgress size={18} />
            <Typography
              variant="body1"
              fontSize={"0.85rem"}
              textAlign={"center"}
              fontWeight={600}
            >
              {"Fetching Status...."}
            </Typography>
          </Stack>
        </>
      );
    }
    if (state.status === "FAILED") {
      return (
        <>
          {/* <Breadcrumb
                    title="Extract Products"
                    items={BCrumb}
                /> */}

          <Stack
            spacing={1}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Stack direction={"row"} spacing={0.5}>
              <ErrorOutline fontSize="small" color="error" />
              <Typography
                variant="body1"
                fontSize={"0.85rem"}
                textAlign={"center"}
                color={"error.main"}
                fontWeight={600}
              >
                {"File processing failed on server. Retry."}
              </Typography>
            </Stack>
            <Button variant="text" onClick={handleRetry}>Retry</Button>
          </Stack>
        </>
      );
    }
     if (state.status === "COMPLETED") {
      return (
        <>
          {/* <Breadcrumb
                    title="Extract Products"
                    items={BCrumb}
                /> */}

          <Stack
            spacing={1}
            direction={"row"}
            alignItems={"center"}
          >
           
              <CheckCircleOutlined fontSize="small" color="success" />
              <Typography
                variant="body1"
                fontSize={"0.85rem"}
                textAlign={"center"}
                color={"success.main"}
                fontWeight={600}
              >
                {"File processing completed successfully."}
              </Typography>
           
           
          </Stack>
        </>
      );
    }
  };

  return <>{processCode && renderData()}</>;
};
